const Mailchimp = function () {

  jQuery(function ($) {

    console.log('icamiami-widgets: Mailchimp script loaded');

    const forms = document.querySelectorAll('.icam-subscribe-form');

    forms.forEach(form => {
      const inputs = form.querySelectorAll('input[type="text"], input[type="email"]');
      const errorResponse = form.querySelector('.icam-error-response');
      const successResponse = form.querySelector('.icam-success-response');
      const emailRegex = /^([a-zA-Z0-9_.-\\+])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;

      const tagsElement = form.querySelector('.icam-mailchimp-tags');
      const tags = tagsElement ? tagsElement.dataset.tags : '';

      // Function to update the error state and message
      function updateErrorState(input, isValid, message = '') {
        const errorSpan = form.querySelector(`.error-${input.classList[0]}`);
        const errorSpanForInput = form.querySelector(`[data-error-for="${input.name}"]`);
        if (!errorSpanForInput) return;

        if (!isValid) {
          input.setAttribute('data-state', 'invalid');
          input.setAttribute('data-error', message);
          errorSpanForInput.textContent = message;
          errorSpanForInput.classList.remove('invisible');
        } else {
          input.setAttribute('data-state', 'valid');
          input.removeAttribute('data-error');
          errorSpanForInput.textContent = '';
          errorSpanForInput.classList.add('invisible');
        }
      }

      // Function to validate an input field
      function validateField(input) {
        let isValid = true;
        let message = '';

        if (!input.value.trim()) {
          isValid = false;
          message = `${input.placeholder} is required.`;
        } else if (input.type === 'email' && !emailRegex.test(input.value.trim())) {
          isValid = false;
          message = 'Please enter a valid email.';
        }

        updateErrorState(input, isValid, message);
        return isValid;
      }

      // Validate fields on blur
      inputs.forEach((input) => {
        input.addEventListener('blur', () => validateField(input));
      });

      // Form submit handler
      form.addEventListener('submit', (e) => {
        e.preventDefault();

        console.log('Form submitted for form:', form);

        const formData = {};
        inputs.forEach((input) => {
          formData[input.name] = input.value;
        });

        // Clear previous responses
        if (errorResponse) {
          errorResponse.textContent = '';
          errorResponse.classList.add('invisible');
        }
        if (successResponse) {
          successResponse.textContent = '';
          successResponse.classList.add('invisible');
        }

        let isValidForm = true;

        // Validate all fields
        inputs.forEach((input) => {
          if (!validateField(input)) {
            isValidForm = false;
          }
        });

        if (!isValidForm) return;

        jQuery.ajax({
          type: 'POST',
          url: icamiami.ajax_url,
          data: {
            action: 'icam_mailchimp_subscribe',
            ...formData,
            TAGS: tags,
          },
          beforeSend: () => {
            console.log('Submitting form data:', formData);
            form.querySelector('.icam-subscribe').setAttribute('disabled', 'disabled');
            const spinner = form.querySelector('.loading-spinner');
            if (spinner) spinner.classList.remove('invisible');
          },
          success: (res) => {
            const data = JSON.parse(res);

            form.querySelector('.icam-subscribe').removeAttribute('disabled');
            const spinner = form.querySelector('.loading-spinner');
            if (spinner) spinner.classList.add('invisible');

            if (data) {
              if (successResponse) {
                successResponse.textContent = data.message;
              }
              successResponse.classList.remove('invisible');
              if (errorResponse) errorResponse.classList.add('invisible');
              form.reset();
              inputs.forEach((input) => input.setAttribute('data-state', 'pristine'));
            } else {
              if (errorResponse) {
                errorResponse.textContent = data.message;
              }
              errorResponse.classList.remove('invisible');
              if (successResponse) successResponse.classList.add('invisible');
            }
          },
          error: (error) => {
            const rt = error.responseText.slice(0, -1)
            let parsedError = null;
            try {
              parsedError = JSON.parse(rt);
            } catch (e) {
              console.error('Error parsing AJAX response:', e, 'Response text:', rt);
            }

            const type = parsedError?.type;
            const message = parsedError?.message;

            form.querySelector('.icam-subscribe').removeAttribute('disabled');
            const spinner = form.querySelector('.loading-spinner');
            if (spinner) spinner.classList.add('invisible');


            if ((type == 'error' && message && message.includes('subscribed'))) {
              if (successResponse) {
                successResponse.textContent = 'You have already subscribed! Thank you!';
              }
              successResponse.classList.remove('invisible');
              if (errorResponse) errorResponse.classList.add('invisible');
              form.reset();
              inputs.forEach((input) => input.setAttribute('data-state', 'pristine'));
              return;
            }

            if (type == 'success') {
              if (successResponse) {
                successResponse.textContent = message;
              }
              successResponse.classList.remove('invisible');
              if (errorResponse) errorResponse.classList.add('invisible');
              form.reset();
              inputs.forEach((input) => input.setAttribute('data-state', 'pristine'));
              return;
            }

            if (errorResponse) {
              errorResponse.textContent = 'An error occurred. Please try again later.';
            }
            errorResponse.classList.remove('invisible');
            if (successResponse) successResponse.classList.add('invisible');

            console.error('AJAX Error:', error);
          },
        });
      });
    });

  });
};

module.exports = Mailchimp;